// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  localDevelopment: false,
  production: 'PRODUCTION_BOOL',
  googleAnalytics: {
    isOn: 'GA_ON',
    uCode: ''
  },
  oauth: {
    client_id: 'boston',
    client_secret: 'boston$ecret'
  },
  // Redirect false When using dev for GWIM and testing directly luma-app with its login modal
  redirectOnAuthenticationError: 'REDIRECT_ON_ERROR',
  environmentName: 'qa',
  isDynatraceEnabled: 'DYNATRACE_ENABLED',
  showEnvBanner: 'SHOW_ENV_BANNER',
  hosts: {
    api_gateway: 'https://scg.bqa.lumafintech.com',
    go: 'https://go.bqa.lumafintech.com',
    navian: 'https://qa-www.lumafintech.com',
    portal: 'https://qaportal.lumafintech.com',
    zuul_gateway: 'https://bqa.lumafintech.com',
    pdf_gateway: 'https://pdf.bqa.lumafintech.com'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
